import { Location, FileMediaData, YoutubeVideo, ContactData } from "../models"
export class Venue {
	public storageId: number
	public name: string
	public entryInfo: string
	public description: string
	public website: string
	public location: Location = new Location()
	public youTubeVideos: YoutubeVideo[];
	public images: FileMediaData[];
	public miscFiles: FileMediaData[];
	public contacts: ContactData[];
}



// WEBPACK FOOTER //
// ./src/app/models/venue.model.ts